import Seo from '../components/Seo';
import { PAGES } from '../seo/meta.mjs';

const Terms = () => {
  return (
    <div className="min-h-screen pt-20 bg-slate-950" data-testid="terms-page">
      <Seo {...PAGES.terms} />
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-24">
        <h1 className="font-heading font-light text-4xl md:text-6xl tracking-tighter text-white mb-12">
          Terms of <span className="text-ocean-500">Service</span>
        </h1>
        <div className="space-y-8 text-slate-400 leading-relaxed">
          <section>
            <h2 className="font-heading text-2xl font-semibold text-white mb-4">Use of This Website</h2>
            <p>
              This website is provided by Ytek Controls to share information about our products, services and
              completed projects. By using the site you agree to use it lawfully and not to attempt to disrupt
              its operation or access non-public areas.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold text-white mb-4">Product and Service Information</h2>
            <p>
              Specifications, capabilities and project details shown on this website are indicative and provided
              for general information. Final specifications for any product or service are defined in the
              corresponding quotation or contract. Content may be updated without notice.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold text-white mb-4">Intellectual Property</h2>
            <p>
              The Ytek Controls name, logo and website content are the property of Ytek Controls unless
              otherwise noted. You may not reproduce or use them for commercial purposes without written
              permission.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold text-white mb-4">Limitation of Liability</h2>
            <p>
              While we aim to keep the information on this site accurate and current, it is provided
              &quot;as is&quot; without warranties of any kind. Ytek Controls is not liable for decisions made
              solely on the basis of website content.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-2xl font-semibold text-white mb-4">Contact</h2>
            <p>
              Questions about these terms can be sent to{' '}
              <a href="mailto:info@ytekcontrols.com" className="text-ocean-500 hover:text-ocean-400">
                info@ytekcontrols.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
